import { useEffect, useRef, useState } from 'react';
import api from '../api';

export default function useServerDraft(enc, kind, initial) {
  const [value, setValue] = useState(initial);
  const [loaded, setLoaded] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/portal/event-draft/${enc}/${kind}`)
      .then(r => { if (!cancelled && r.data) setValue(p => ({ ...p, ...r.data })); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [enc, kind]);

  useEffect(() => {
    if (!loaded) return undefined;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => { api.put(`/portal/event-draft/${enc}/${kind}`, value).catch(() => {}); }, 700);
    return () => clearTimeout(timer.current);
  }, [value, loaded, enc, kind]);

  return [value, setValue];
}
